import { NotifyHelper } from "../../../helpers/toast";
import { eHinhThucThiActionsObj } from "../../action-types/tct/IHinhThucThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const hinhThucThiActions = {
    ...generateActions(eHinhThucThiActionsObj, "HINH_THUC_THI"),
    ...generateActionForKey(eHinhThucThiActionsObj, "HINH_THUC_THI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eHinhThucThiActionsObj, "HINH_THUC_THI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eHinhThucThiActionsObj, "HINH_THUC_THI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eHinhThucThiActionsObj, "HINH_THUC_THI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
